import { Entity, FieldType } from 'gossamer-unified';
import { InstitutionGroup, UserView } from 'cb-model';

export interface GroupBookingUploadRow {
  user_id: string;
  institution_group_id: number;
}

export const GroupBookingUpload: Entity<GroupBookingUploadRow> = {
  id: 'GroupBookingUpload',
  title: 'Group Booking',
  service: 'main',
  rowLabel: (row: GroupBookingUploadRow) => `${row.user_id} (${row.institution_group_id})`,
  primaryKeyFields: [],
  security: [],
  fields: {
    user_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'User',
      listColumn: true,
      refEntity: UserView,
      description: 'the 36-character UUID of the user, e.g. abc12345-6789-0123-4567-8901abcdef23',
    },
    institution_group_id: {
      seq: 12,
      type: FieldType.Reference,
      label: 'Institution Group',
      listColumn: true,
      refEntity: InstitutionGroup,
      description: 'the id number of the institution group, e.g. 12345',
    },
  },
};
